import React from "react";
import PageTitle from "../components/pageTitle.js";

function About() {
  return (
    <div className="min-h-screen bg-white px-6 py-10">
      <div className="max-w-5xl mx-auto">
        <div>
          <PageTitle title="시설안내" />
        </div>

        {/* 시설안내 사진 - 세로 스크롤 형태 */}
        <section className="space-y-6 mt-6">
          {[
            "/images/aboutImg1.jpeg",
            "/images/aboutImg2.jpeg",
            "/images/aboutImg3.jpeg",
            "/images/aboutImg4.jpeg",
            "/images/aboutImg5.jpeg",
            "/images/aboutImg6.jpeg",
            "/images/aboutImg7.jpeg",
            "/images/aboutImg8.jpeg",
            "/images/aboutImg9.jpeg",
            "/images/aboutImg10.jpeg",
          ].map((src, idx) => (
            <img
              key={idx}
              src={src}
              alt={`시설 이미지 ${idx + 1}`}
              className="w-full object-cover shadow hover:shadow-lg transition"
            />
          ))}
        </section>
      </div>
    </div>
  );
}

export default About;
